module.exports = __webpack_public_path__ + "static/media/icon-supplies-acetone.20545970.svg";